import { render, staticRenderFns } from "./lock-children.vue?vue&type=template&id=3abff880&scoped=true&lang=pug&"
import script from "./lock-children.vue?vue&type=script&lang=ts&"
export * from "./lock-children.vue?vue&type=script&lang=ts&"
import style0 from "./lock-children.vue?vue&type=style&index=0&id=3abff880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abff880",
  null
  
)

export default component.exports